import type { DecodedClaims } from './jwt';

/** ADR-0001: drei Rollen, gesetzt vom Pre-Token-Trigger aus der Benutzertabelle. */
export type Role = 'admin' | 'vorstand' | 'abteilungsleiter';

const GROUP_BY_ROLE: Record<Role, string> = {
  admin: 'admins',
  vorstand: 'vorstand',
  abteilungsleiter: 'abteilungsleiter',
};

export function rolesFromClaims(claims: DecodedClaims | undefined): Role[] {
  if (!claims) return [];
  return (Object.keys(GROUP_BY_ROLE) as Role[]).filter((role) =>
    claims.groups.includes(GROUP_BY_ROLE[role]),
  );
}
